import React, { FunctionComponent } from 'react'
import { DATE_TIME_MEDIUM, formatDateTime } from '@vend/utilities'
import { T } from '@transifex/react'
import { RegisterClosure } from '../../util/register-closure-types'

const FEILD_CONTEXT = 'Label for register closure summary field'

interface RegisterDetailsProps {
  summary: RegisterClosure
}

export const RegisterDetails: FunctionComponent<RegisterDetailsProps> = ({
  summary,
}) => {
  return (
    <>
      <div className="wr-info-field">
        <div className="wr-info-field-label vd-pr2">
          <T _str="Outlet" _context={FEILD_CONTEXT} />
        </div>
        <div className="wr-info-field-value">{summary.outlet.name}</div>
      </div>
      <div className="wr-info-field">
        <div className="wr-info-field-label vd-pr2">
          <T _str="Register" _context={FEILD_CONTEXT} />
        </div>
        <div className="wr-info-field-value">{summary.register.name}</div>
      </div>
      <div className="wr-info-field">
        <div className="wr-info-field-label vd-pr2">
          <T _str="Closure #" _context={FEILD_CONTEXT} />
        </div>
        <div className="wr-info-field-value">
          {summary.register_closure_sequence_number}
        </div>
      </div>
      <div className="wr-info-field">
        <div className="wr-info-field-label vd-pr2">
          <T _str="Opening time" _context={FEILD_CONTEXT} />
        </div>
        <div className="wr-info-field-value">
          {formatDateTime(summary.register_open_time, DATE_TIME_MEDIUM)}
        </div>
      </div>
      {summary.register_close_time ? (
        <div className="wr-info-field">
          <div className="wr-info-field-label vd-pr2">
            <T _str="Closing time" _context={FEILD_CONTEXT} />
          </div>
          <div className="wr-info-field-value">
            {formatDateTime(summary.register_close_time, DATE_TIME_MEDIUM)}
          </div>
        </div>
      ) : null}
    </>
  )
}
